import React, { Component } from 'react';



class procreate extends Component {

    render() {
        
        return (
            <section>

            <section className="container section">
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/9.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/8.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/7.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/6.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/5.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/4.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/3.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/2.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div>
                {/* <div className="col s12 m6 l3">
                    <div className="card">
                    <div className="card-image">
                        <img src="../procreate/1.png" alt="" className="responsive-img materialboxed"/>
                    </div>
                    </div>
                </div> */}
            </div>
            </section> 
        
        </section>

        )
    }
}




export default procreate;